var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"payment-loading d-flex flex-column"},[_c('Purenavbar'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":require("../../public/fdtiger-offical-site-img/order/tigermaster_logo.png"),"alt":"tigermaster_logo"}}),_c('p',[_vm._v("正跳轉至師虎來了......")])])
}]

export { render, staticRenderFns }